import catGif from 'data/img/cat-animation.gif';
import { Cat } from './AnimationCat.styled';

export const AnimationCat = () => {
  return <Cat src={catGif} alt="crazy cat" />;
};
